import { motion } from "framer-motion";
import styled from "styled-components";
import { fonts } from "../../../styles/variables.js";

export const SkillsContainer = styled(motion.div)`
   display: flex;
   justify-content: center;
   flex-wrap: wrap;
   margin-top: 2rem;
`;

export const Skill = styled(motion.div)`
   width: 7.6rem;
   height: 8.2rem;
   border: 2px solid;
   border-radius: 0 1.6rem 1.6rem;
   text-align: center;
   padding: 1.4rem 0;
   margin: 1rem 1rem 1rem;

   @media (max-width: 1366px) {
      border: 1px solid;
   }

   @media (max-width: 900px) {
      width: 7rem;
      height: 7.6rem;
      margin: 0.7rem;
      border-radius: 0 1.3rem 1.3rem;
   }

   @media (max-width: 407px) {
      width: 6.2rem;
      height: 6.8rem;
      margin: 0.6rem;
   }

   .skill-icon {
      width: 40%;
      height: auto;

      img {
         width: 100%;
      }
   }
`;

export const SkillTitle = styled.p`
   font-family: ${fonts.main};
   font-weight: 600;
   font-size: 0.85rem;
   letter-spacing: 1px;
   color: #717171;

   margin-top: 0.5rem;

   @media (max-width: 407px) {
      letter-spacing: 0;
   }
`;
